import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag, Typography } from 'antd';

import type { NTags } from '@app/types';
import { getContrastYIQ } from '@app/utils/getContrastYIQ';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { DefaultOptionType } from 'antd/es/select';

type GetTagsSelectorDataType = (arg: {
  tags: NTags.Tag[];
}) => DefaultOptionType[];

const { Text } = Typography;

export const getTagsSelectorData: GetTagsSelectorDataType = ({ tags }) =>
  tags.map(({ Id, IconId, Name, Color = 'white' }) => {
    const color = getContrastYIQ(Color);
    return {
      label: (
        <Tag
          key={IconId}
          icon={
            <FontAwesomeIcon
              className="tag-icon"
              icon={IconId as IconProp}
              style={{ color }}
            />
          }
          color={Color}
        >
          <Text style={{ color }}>{Name}</Text>
        </Tag>
      ),
      value: Id,
      name: Name,
    };
  });
